export enum Levels{
    YEA = "YEA",
    MON = "MON",
    WEE = "WEE",
    DOW = "DOW",
    DAY = "DAY",
    HOD = "HOD",
}